import {
  Box,
  VStack,
  HStack,
  SimpleGrid,
  Button,
  Center,
  Text,
} from "@chakra-ui/react";
import { Display02, Display03, Label01, Paragraph01 } from "~/components/Texts";
import { FiMessageCircle, FiMail, FiExternalLink } from "react-icons/fi";
import { CgCommunity } from "react-icons/cg";
import { IoLogoWhatsapp } from "react-icons/io5";
import AnimatedEntryOnViewport from "~/components/animations/AnimatedEntryOnViewport";
import Img from "react-optimized-image";
import BackgroundImage from "~/public/marketing/support_header_bg.png";

export default function SupportSectionChannels() {
  return (
    <Box
      position="relative"
      w="100vw"
      minH="100vh"
      backgroundColor="light.background.superLite"
    >
      <Box position="absolute" top="0" right="0" w="100vw" minH="100vh">
        <Img
          style={{
            width: "100vw",
            height: "100vh",
            objectFit: "cover",
          }}
          src={BackgroundImage}
          webp
          sizes={[300, 600, 900, 1200, 1600]}
          densities={[1, 2]} // Retina support
          draggable="false"
          loading="lazy"
          alt="Gente sonriendo porque encontraron ayuda para hacer su negocio en internet."
        />
      </Box>

      <VStack>
        <Center
          w="100%"
          minH="100vh"
          pt="20"
          px={{ base: "2", sm: "4", md: "6", lg: "14", xl: "16" }}
          maxW="1400px"
          alignSelf="center"
        >
          <AnimatedEntryOnViewport>
            <VStack w="100%" h="100%" spacing="20">
              <Display02 textAlign="center">
                Sabemos que tener un negocio no es fácil, nosotros también
                tenemos uno.
              </Display02>
              <Display03 textAlign="center">
                Por eso no usamos bots, te ayudamos personalmente 😍.
              </Display03>
              <SimpleGrid
                w="100%"
                align="flex-start"
                columns={{ base: 1, md: 2, lg: 4 }}
                spacing="4"
              >
                <VStack
                  flex="1"
                  borderRadius="brand"
                  backgroundColor="light.background.strong"
                  borderWidth="2px"
                  borderColor="action.secondary"
                  p="4"
                  align="flex-start"
                  spacing="4"
                  boxShadow="sm"
                >
                  <HStack>
                    <Label01>
                      <CgCommunity />
                    </Label01>
                    <Label01>Comunidad</Label01>
                  </HStack>
                  <Text
                    textStyle={{
                      base: "paragraph02",
                      md: "paragraph01",
                    }}
                  >
                    Encontrá emprendedores como vos, aprendé a usar la
                    plataforma y solicitá nuevas funcionalidades en nuestra
                    comunidad.
                  </Text>
                  <Box flex="1" />
                  <a
                    href="https://shopstory.peerboard.com"
                    target="_blank"
                    rel="noopener"
                  >
                    <Button
                      colorScheme="secondary"
                      rightIcon={<FiExternalLink />}
                    >
                      Ir a la comunidad
                    </Button>
                  </a>
                </VStack>
                <VStack
                  flex="1"
                  borderRadius="brand"
                  backgroundColor="light.background.strong"
                  p="4"
                  align="flex-start"
                  boxShadow="sm"
                >
                  <HStack>
                    <Label01>
                      <FiMessageCircle />
                    </Label01>
                    <Label01>Web Chat</Label01>
                  </HStack>
                  <Text
                    textStyle={{
                      base: "paragraph02",
                      md: "paragraph01",
                    }}
                  >
                    Podemos ayudarte dede el chat en nuestro sitio web. Hace
                    click en la burbuja de abajo a la derecha.
                  </Text>
                </VStack>
                <VStack
                  flex="1"
                  borderRadius="brand"
                  backgroundColor="light.background.strong"
                  p="4"
                  align="flex-start"
                  boxShadow="sm"
                >
                  <HStack>
                    <Label01>
                      <IoLogoWhatsapp />
                    </Label01>
                    <Label01>WhatsApp</Label01>
                  </HStack>
                  <Paragraph01>
                    <b>(+54) 11-3985-7289</b>
                  </Paragraph01>
                  <Text
                    textStyle={{
                      base: "paragraph02",
                      md: "paragraph01",
                    }}
                  >
                    Te acompañamos a donde vayas desde tu celular.
                  </Text>
                  <Box flex="1" />
                  <a
                    href="https://wa.me/message/7G7JOHQIHHDLI1"
                    target="_blank"
                    rel="noopener"
                  >
                    <Button colorScheme="brandStrong" variant="outline">
                      Enviar mensaje
                    </Button>
                  </a>
                </VStack>
                <VStack
                  flex="1"
                  borderRadius="brand"
                  backgroundColor="light.background.strong"
                  p="4"
                  align="flex-start"
                  boxShadow="sm"
                >
                  <HStack>
                    <Label01>
                      <FiMail />
                    </Label01>
                    <Label01>Correo electrónico</Label01>
                  </HStack>
                  <Paragraph01>
                    <b>ayuda@shopstory.io</b>
                  </Paragraph01>
                  <Text
                    textStyle={{
                      base: "paragraph02",
                      md: "paragraph01",
                    }}
                  >
                    ¿Preferis un cálido email?, normalmente respondemos dentro
                    de las 48hs.
                  </Text>
                  <Box flex="1" />
                  <a
                    href="mailto:ayuda@shopstory.io"
                    target="_blank"
                    rel="noopener"
                  >
                    <Button colorScheme="brandStrong" variant="outline">
                      Enviar correo
                    </Button>
                  </a>
                </VStack>
              </SimpleGrid>
            </VStack>
          </AnimatedEntryOnViewport>
        </Center>
      </VStack>
    </Box>
  );
}
